(function () {
  angular.module("akitabox.desktop.dashboard", [
    "akitabox.core.services.building",
    "akitabox.core.services.flag",
    "akitabox.core.services.organization",
    "akitabox.core.toast",
  ]);
})();
